/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
var ToastContext = createContext(null);
function useToast() {
    return useContext(ToastContext);
}
export { ToastContext, useToast };
